import React, {useRef,useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {ChatEngine} from 'react-chat-engine';
import {auth} from './firebase'
import {useAuth} from '../context/authContext'
import axios from 'axios'
const Chats = () =>{
    const history = useHistory();
    const {user} = useAuth()
    const [loading, setLoading] = useState(true)
    console.log(user)
    const handleLogout = async () =>{
        await auth.signOut();
        history.push('/')
    }
    const getFile = async(url) =>{
        const response = await fetch(url)
        const data = await response.blob()
        return new File([data], 'userPhoto.jpg', {type: 'image/jpeg'})
    }
    useEffect(() =>{
        if(!user){
            history.push('/');
            return;
        }
        axios.get('https://api.chatengine.io/users/me', {
            headers:{
                'project-id':'8543485a-9cde-4900-9c0a-30187ed98a41',
                'user-name':user.email,
                'user-secret': user.uid
                

            }
        })
        .then(()=>{
            setLoading(false);
        })
        .catch(() =>{
            let formdata = new FormData();
            formdata.append('email', user.email)
            formdata.append('username', user.email)
            formdata.append('secret', user.uid)
            getFile(user.photoURL).then((avatar) =>{
                formdata.append('avatar', avatar, avatar.name)
                axios.post('https://api.chatengine.io/users',
                   formdata,
                   {headers:{'private-key': '0669a42e-26d7-407d-9d3b-21630cf0311b'}}
                )
                .then(()=> setLoading(false))
                .catch((err) => console.log(err))
            })
        })
    },[user, history])
    if(!user || loading) return 'loading....'
    return (
        <div className ='chats-page'>
            <div className='nav-bar'>
                <div className ='logo-tab'>
                    Unichat
                </div >
                <div onClick={handleLogout} className='logout-tab'>
                   Logout
                </div>
            </div>
            <ChatEngine
                height ='calc(100vh - 66px)'
                projectID = '8543485a-9cde-4900-9c0a-30187ed98a41'
                userName={user.email}
                userSecret={user.uid}
            />
          
        </div>
    )
}
export default Chats;